var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_vm.type == 'idcard' ? _c('LoginAggr') : _c('Login')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };